import NavMenu from "components/shared/nav-menu";
import { useNavItems } from "hooks/useNavItems";
import { useFlags } from "utils";

import { MultiPolicySelector } from "../multi-policy-selector";
import styles from "./navigation.module.scss";

export const Navigation = () => {
  const navItems = useNavItems();
  const { policyPage: isPolicyPageEnabled } = useFlags();

  return (
    <div className={styles.navigation} data-testid="secondary-header">
      {!isPolicyPageEnabled ? (
        <div className={styles.policyAddressContainer}>
          <MultiPolicySelector />
        </div>
      ) : null}
      <NavMenu navItems={navItems} />
    </div>
  );
};
